import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { ApolloProvider } from '@apollo/client/react';
import client from './apollo/client';
import Login from './components/auth/Login';
import Dashboard from './components/dashboard/Dashboard';
import Projects from './components/projects/Projects';
import ProjectDetails from './components/projects/ProjectDetails';
import Planning from './components/planning/Planning';
import TasksList from './components/tasks/TasksList';
import TaskBoard from './components/boards/TaskBoard';
import BoardsList from './components/boards/BoardsList';
import UnitDetails from './components/facilities/UnitDetails';
import FacilityReport from './components/facilities/FacilityReport';
import Facilities from './components/facilities/Facilities';
import FacilityDetails from './components/facilities/FacilityDetails';
import AreaDetails from './components/facilities/AreaDetails';
import Reports from './components/reports/Reports';
import Layout from './components/layout/Layout';
import ProtectedRoute from './components/auth/ProtectedRoute';

const theme = createTheme({
  palette: {
    primary: {
      main: '#1976d2',
    },
    secondary: {
      main: '#dc004e',
    },
  },
});

function App() {
  const isTestEnv = window.location.hostname.includes('staging');

  return (
    <ApolloProvider client={client}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        {isTestEnv && (
          <div
            style={{
              position: 'fixed',
              left: '50%',
              transform: 'translateX(-50%)',
              fontSize: '2.5rem',
              fontWeight: 'bold',
              color: 'red',
              zIndex: 9999,
              pointerEvents: 'none',
              textAlign: 'center'
            }}
          >
            Test Version (Staging Environment)
          </div>
        )}
        <Router>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route
              path="/dashboard"
              element={
                <ProtectedRoute>
                  <Layout>
                    <Dashboard />
                  </Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/projects"
              element={
                <ProtectedRoute>
                  <Layout>
                    <Projects />
                  </Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/projects/:id"
              element={
                <ProtectedRoute>
                  <Layout>
                    <ProjectDetails />
                  </Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/projects/:id/:elementId"
              element={
                <ProtectedRoute>
                  <Layout>
                    <ProjectDetails />
                  </Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/planning"
              element={
                <ProtectedRoute>
                  <Layout>
                    <Planning />
                  </Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/tasks"
              element={
                <ProtectedRoute>
                  <Layout>
                    <TasksList />
                  </Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/boards"
              element={
                <ProtectedRoute>
                  <Layout>
                    <BoardsList />
                  </Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/boards/:boardId"
              element={
                <ProtectedRoute>
                  <Layout>
                    <TaskBoard />
                  </Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/projects/:projectId/unit/:unitName"
              element={
                <ProtectedRoute>
                  <Layout>
                    <UnitDetails />
                  </Layout>
                </ProtectedRoute>
              }
            />

            <Route
              path="/facilities"
              element={
                <ProtectedRoute>
                  <Layout>
                    <Facilities />
                  </Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/facilities/:id"
              element={
                <ProtectedRoute>
                  <Layout>
                    <FacilityDetails />
                  </Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/facilities/:facilityId/:areaId"
              element={
                <ProtectedRoute>
                  <Layout>
                    <AreaDetails />
                  </Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/reports"
              element={
                <ProtectedRoute>
                  <Layout>
                    <Reports />
                  </Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/reports/facility-report"
              element={
                <ProtectedRoute>
                  <Layout>
                    <FacilityReport />
                  </Layout>
                </ProtectedRoute>
              }
            />

            <Route path="/" element={<Navigate to="/dashboard" replace />} />
          </Routes>
        </Router>
      </ThemeProvider>
    </ApolloProvider>
  );
}

export default App;
